import { Nullable } from "./GenericTypes";

export enum TaxIdentificationType {
  ID = 1,
  PASSPORT = 2,
  GOVERNMENTAL = 3,
  RIF = 4,
  FOREIGN = 5,
  COMMUNES = 57,
}

export interface AccountPhoneInterface extends AccountPhoneRequestInterface {
  phoneID: string;
  accountID: string;
  phoneTypeID: number;
}

export interface AccountPhoneRequestInterface {
  phoneID: Nullable<string>;
  accountID: Nullable<string>;
  countryID: number;
  phoneNumber: string;
  countryPhoneAccessCode: Nullable<string>;
}
export interface AccountEmailRequestInterface {
  emailID: Nullable<string>;
  accountID: Nullable<string>;
  email: string;
  emailTypeID: number;
}
export interface AccountEmailInterface extends AccountEmailRequestInterface {
  emailID: string;
  accountID: string;
}

export interface AccountInterface extends AccountRequestInterface {
  id: string;
  accountCode: string;
  listAccountPhone: AccountPhoneInterface[];
  listAccountEmail: AccountEmailInterface[];
  agreementID?: Nullable<string>;
  accountSiteID?: Nullable<number>;
  acountBillTo?: Nullable<string>;
  accountSiteName?: Nullable<string>;
  accountSiteCode?: Nullable<string>;
}

export interface AccountRequestInterface {
  id: Nullable<string>;
  accountTypeID?: number;
  fiscalAddress?: string;
  fiscalPhoneNumber?: string;
  countryID?: number;
  accountCode: Nullable<string>;
  taxIdentificationTypeID: Nullable<number>;
  taxIdentificationTypeCode: Nullable<string>;
  abreviationName: string;
  identificationNumber: string;
  accountFullName: string;
  listAccountPhone: AccountPhoneRequestInterface[];
  listAccountEmail: AccountEmailRequestInterface[];
  listAuthorizingAccount: AccountInterface[];
  creationUser?: Nullable<string>;
  creationDate?: string;
}
